import styled from 'styled-components';

interface SectionProps {
  backgroundColor?: string;
  backgroundImage?: string;
}

export const Section = styled.section<SectionProps>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.lg} 0;
  background: ${({ backgroundColor, theme }) => backgroundColor || theme.colors.white};
  ${({ backgroundImage }) =>
    backgroundImage &&
    `
    background-image: url(${backgroundImage});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  `}

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 1.5rem 0;
  }
`;

export const SectionContent = styled.div`
  margin: 0 auto;
  padding: 0 6rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0 ${({ theme }) => theme.spacing.sm};
  }
`;
